import { render, staticRenderFns } from "./question_record.vue?vue&type=template&id=0f6d449a"
import script from "./question_record.vue?vue&type=script&lang=js"
export * from "./question_record.vue?vue&type=script&lang=js"
import style0 from "./question_record.vue?vue&type=style&index=0&id=0f6d449a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports